// Round Robin API — Phase RR1. Mirrors tournamentApi.js.
import axios from 'axios';
import { tokenStore } from './api';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const client = axios.create({ baseURL: API, withCredentials: true });
client.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export const roundRobinAPI = {
  list:   ()      => client.get('/round-robins'),
  create: (p)     => client.post('/round-robins', p),
  get:    (id)    => client.get(`/round-robins/${id}`),
  update: (id, p) => client.patch(`/round-robins/${id}`, p),
  remove: (id)    => client.delete(`/round-robins/${id}`),
  restore: (id)   => client.post(`/round-robins/${id}/restore`),

  // Flyer (Phase T2.0A Prompt 2)
  uploadFlyer: (id, file) => client.post(`/round-robins/${id}/flyer`, file, {
    headers: { 'Content-Type': file.type || 'application/octet-stream' },
  }),
  deleteFlyer: (id) => client.delete(`/round-robins/${id}/flyer`),

  addEntry:    (id, p)     => client.post(`/round-robins/${id}/entries`, p),
  updateEntry: (id, entryId, payload) =>
                              client.patch(`/round-robins/${id}/entries/${entryId}`, payload),
  removeEntry: (id, entryId) => client.delete(`/round-robins/${id}/entries/${entryId}`),
  replacePlayer: (id, entryId, body) => client.post(`/round-robins/${id}/entries/${entryId}/replace-player`, body),
  assignPools: (id, assignments = []) => client.put(`/round-robins/${id}/pools`, { assignments }),

  // Pool Builder (RR Update 1, Feb 2026)
  createPool:  (id)          => client.post(`/round-robins/${id}/pools`),
  renamePool:  (id, pn, lbl) => client.patch(`/round-robins/${id}/pools/${pn}/label`, { label: lbl }),
  deletePool:  (id, pn)      => client.delete(`/round-robins/${id}/pools/${pn}`),
  reorderPools:(id, order)   => client.post(`/round-robins/${id}/pools/reorder`, { order }),
  seedPool:    (id, pn, entryIds) =>
                 client.post(`/round-robins/${id}/pools/${pn}/seed`, { pool_number: pn, entry_ids: entryIds }),

  // Schedule generation + manual match control (RR Update 2, Feb 2026)
  generateWith:  (id, opts) => client.post(`/round-robins/${id}/generate`, opts),
  resetSchedule: (id)       => client.post(`/round-robins/${id}/reset-schedule`),
  createMatch:   (id, m)    => client.post(`/round-robins/${id}/matches`, m),
  editMatch:     (id, mid, m) => client.patch(`/round-robins/${id}/matches/${mid}`, m),
  deleteMatch:   (id, mid)  => client.delete(`/round-robins/${id}/matches/${mid}`),

  // Live scheduling + publication (RR Update 3, Feb 2026)
  autoSchedule:  (id, opts = {}) => client.post(`/round-robins/${id}/auto-schedule`, opts),
  publish:       (id) => client.post(`/round-robins/${id}/publish`),
  unpublish:     (id) => client.post(`/round-robins/${id}/unpublish`),

  generate: (id) => client.post(`/round-robins/${id}/generate`),

  recordResult:   (id, matchId, p) => client.post(`/round-robins/${id}/matches/${matchId}/result`, p),
  clearMatch:     (id, matchId)    => client.post(`/round-robins/${id}/matches/${matchId}/clear`),
  updateSchedule: (id, matchId, p) => client.patch(`/round-robins/${id}/matches/${matchId}/schedule`, p),

  championOverride: (id, p) => client.post(`/round-robins/${id}/champion-override`, p),
};

export const RR_STATUS_LABELS = {
  draft: 'Draft',
  registration_open: 'Registration open',
  registration_closed: 'Registration closed',
  schedule_generated: 'Schedule generated',
  in_progress: 'In progress',
  completed: 'Completed',
  archived: 'Archived',
  cancelled: 'Cancelled',
};
